import { GoogleAnalyticsService } from "../../core/services/google-analytics.service";

export function googleAnalyticsInitializer(googleAnalyticsService: GoogleAnalyticsService): Function {
    return () => googleAnalyticsService.insertAnalyticsInHtmlDocument();
}